<template>
  <div class="content">
    <div class="page-inner">
      <div class="page-header">
        <h4 class="page-title">Podcast</h4>
        <ul class="breadcrumbs">
          <li class="nav-home">
            <router-link to="/dashboard">
              <i class="flaticon-home"></i>
            </router-link>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <router-link to="/podcasts">Podcasts</router-link>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <a href="#" v-if="!podcast._id">{{ $t('new_podcast') }}</a>
            <a href="#" v-if="podcast._id">{{ podcast.name }}</a>
          </li>
        </ul>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card" v-if="!loading">
            <div class="card-header">
              <div class="card-head-row card-tools-still-right">
                <div class="card-title" v-if="!podcast._id">{{ $t('new_podcast') }}</div>
                <div class="card-title" v-if="podcast._id">{{ podcast.name }}</div>
                <div class="card-category d-none d-lg-block d-xl-none">{{ $t('fill_all_required') }}.</div>
                <div class="card-tools">
                  <button @click="removePodcast()" class="btn btn-danger btn-primary btn-sm" v-if="distribution && podcast._id && !podcast.status">
                    <span class="fa fa-trash mr-1"></span> {{ $t('remove') }}
                  </button>
                </div>
              </div>
            </div>
            <form @submit.prevent="submitPodcast()">
              <div class="card-body">
                <div class="form-group form-show-validation row">
                  <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                    {{ $t('podcast_name') }}
                    <span class="required-label">*</span>
                  </label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <select class="form-control p2">
                      <option value=""></option>
                    </select>
                    <button type="button" class="btn btn-sm btn-default mt-2" @click="showNewPodcastModal()">
                      New Podcast
                    </button>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                    {{ $t('episode_name') }}
                    <span class="required-label">*</span>
                  </label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <input type="text" class="form-control">
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                    {{ $t('description') }}
                    <span class="required-label">*</span>
                  </label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <textarea class="form-control"></textarea>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                    {{ $t('publish_date') }}
                    <span class="required-label">*</span>
                  </label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <input type="text" class="form-control">
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('episode_image') }}</label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-file input-file-image" v-if="podcast.cover_image">
                      <img :src="podcast.cover_image" alt="" width="200" class="img-thumbnail"><br/>
                      <button type="button" class="mt-2 btn btn-primary btn-sm" @click="replaceImage()">{{ $t('remove_image') }}</button>
                    </div>
                    <div class="input-file input-file-image" v-if="!podcast.cover_image">
                      <croppa
                        :width="480"
                        :height="480"
                        :prevent-white-space="true"
                        v-model="myCroppa">
                      </croppa>
                      <div class="mt-sm">
                        <button class="btn btn-default btn-sm" type="button" @click="zoomOut()" :disabled="!hasFile">
                          <i class="fa fa-search-minus"></i>
                        </button>
                        <button class="btn btn-default btn-sm" type="button" @click="zoomIn()" :disabled="!hasFile">
                          <i class="fa fa-search-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                    {{ $t('is_explicit') }}
                  </label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <ul class="nav nav-pills nav-primary">
                        <li class="nav-item">
                          <a
                            class="nav-link my-0"
                            :class="{ active: podcast.explicit }"
                            href="javascript:void(0)"
                            @click="setExplicit(true)"
                          >{{ $t('yes') }}</a>
                        </li>
                        <li class="nav-item">
                          <a
                            class="nav-link my-0"
                            :class="{ active: !podcast.explicit }"
                            href="javascript:void(0)"
                            @click="setExplicit(false);"
                          >{{ $t('no') }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                    {{ $t('audio_file') }}
                    <span class="required-label">*</span>
                  </label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <div v-if="podcast.file_url" style="width: 100%;">
                        <div style="width: 100%;">
                          <audio controls preload="metadata" metadata="metadata" :id="`podcast_audio`">
                            <source
                              :src="podcast.file_url"
                              type="audio/wav"
                              v-if="podcast.file_url.match(/\.wav$/, 'i')"
                            />
                            <source
                              :src="podcast.file_url"
                              type="audio/mp3"
                              v-if="podcast.file_url.match(/\.mp3$/, 'i')"
                            />
                            {{ $t('wrong_audio_element') }}
                          </audio>
                        </div>
                        <div class="mt-1">
                          <button class="btn btn-default btn-sm" type="button" @click="replaceAudio()">{{ $t('replace_file') }}</button>
                        </div>
                      </div>
                      <div class="input-file" v-show="!podcast.file_url && !podcast.uploading">
                        <div>
                          <input
                            :ref="`podcastFile`"
                            id="podcast_file"
                            @change="uploadFile()"
                            type="file"
                            class="form-control form-control-file"
                            accept=".wav, .mp3"
                            required
                          />
                          <label :for="`podcast_file`" class="label-input-file btn btn-primary btn-round">
                            <span class="btn-label">
                              <i class="fa fa-file-audio mr-1"></i>
                            </span>
                            {{ $t('select_file') }}
                          </label>
                        </div>
                      </div>
                      <div v-show="podcast.uploading && !podcast.file_url" style="width: 100%;">
                        <div class="progress mt-3" style="height: 8px;">
                          <div
                            class="progress-bar bg-info progress-bar-striped progress-bar-animated"
                            role="progressbar"
                            :style="`width: ${podcast.uploading}%`"
                            :aria-valuenow="podcast.uploading"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            data-toggle="tooltip"
                            data-placement="top"
                            title
                            :data-original-title="`${podcast.uploading}%`"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-action">
                <div class="row">
                  <div class="col-md-12">
                    <router-link to="/podcasts" tag="button" class="btn btn-default btn-border no-border" type="button">{{ $t('cancel') }}</router-link>
                    <button class="btn btn-success" type="submit" :disabled="saving">
                      {{ $t('save') }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div ref="newPodcastModal" class="modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ $t('new_podcast') }}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="">{{ $t('podcast_name') }}</label>
              <input type="text" class="form-control">
            </div>
            <div class="form-group">
              <label for="">Description</label>
              <textarea class="form-control"></textarea>
            </div>
            <div class="form-group">
              <label for="">Category</label>
              <select class="form-control">
                <option value=""></option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-success">
              {{ $t('save') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PodcastForm',
  data: function () {
    return {
      saving: false,
      podcast: {}
    }
  },
  methods: {
    showNewPodcastModal: function () {
      window.$(this.$refs.newPodcastModal).modal('show')
    },
    setExplicit: function (value) {
      this.podcast.explicit = value
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="scss">
select.form-control {
  height: 40px !important;
}

.croppa-container {
  zoom: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/components/PodcastForm.vue